/* Link a visitor-provided preview email to Shopify's native partner analytics.
 * No customer account, marketing subscription, cart attribute or custom event is created.
 */
(() => {
 if(window.__dpVisitorIdentityInstalled)return;
 window.__dpVisitorIdentityInstalled=true;
 if(!['dearplace.studio','www.dearplace.studio','shop.dearplace.studio'].includes(location.hostname))return;
 // Short-lived, explicit QA mode produces only labelled non-conversion test events.
 try{if(new URL(location.href).searchParams.get('dp_commerce_qa')==='1')sessionStorage.setItem('dp.commerce.qa.until',String(Date.now()+10*60000));}catch{}
 let sentEmail='',pending=false,attempts=0;
 const status=value=>{document.documentElement.dataset.dpVisitorIdentity=value;};
 const allowed=()=>window.Shopify?.customerPrivacy?.marketingAllowed?.()===true;
 function email(){
  try{
   const lead=JSON.parse(localStorage.getItem('dp.lovable.preview-lead.v2')||'null');
   if(!lead||!Number.isFinite(lead.expiresAt)||lead.expiresAt<=Date.now()||typeof lead.email!=='string')return '';
   const value=lead.email.trim().toLowerCase();
   return value.length<=254&&/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)?value:'';
  }catch{return '';}
 }
 function sync(){
  if(!allowed()){status('waiting-consent');sentEmail='';return;}
  const value=email();
  if(!value){status('no-email');return;}
  if(value===sentEmail||pending)return;
  if(typeof window.Shopify?.analytics?.visitor!=='function'){status('waiting-api');return;}
  try{
   pending=true;
   const result=window.Shopify.analytics.visitor({email:value});
   Promise.resolve(result).then(accepted=>{
    if(accepted===true){sentEmail=value;status('accepted');}
    else status('not-accepted');
   }).catch(()=>status('unavailable')).finally(()=>{pending=false;});
  }catch{pending=false;status('unavailable');}
 }
 document.addEventListener('visitorConsentCollected',sync);
 document.addEventListener('dp:preview-email-saved',sync);
 window.addEventListener('pageshow',sync);
 window.addEventListener('storage',event=>{if(event.key==='dp.lovable.preview-lead.v2')sync();});
 // Run before ordinary cart/checkout interactions; never delay those actions.
 document.addEventListener('click',sync,true);
 const timer=setInterval(()=>{sync();if(++attempts>=120)clearInterval(timer);},500);
 sync();
})();
